

























































import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({ components: {} })
export default class extends Vue {
  @Prop() public readonly inHouseAds!: 'remunerada' | 'solidaria' | 'both' | 'none' | 'remunerada_sobdemanda';
  @Prop() private readonly instanceSlug!: string;
  @Prop() private readonly journeyId!: number;

  public get link() {
    if (this.inHouseAds === 'remunerada') {
      return `https://app.pesquisaremunerada.com.br/#/login?utm_source=${this.instanceSlug}&utm_medium=survey&utm_campaign=landing_pesquisaremunerada`;
    } else if (this.inHouseAds === 'solidaria') {
      return `https://app.pesquisasolidaria.com.br/#/login?utm_source=${this.instanceSlug}&utm_medium=survey&utm_campaign=survey_pesquisasolidaria`;
    } else {
      return `https://app.pesquisaremunerada.com.br/#/landing/?utm_source=${this.instanceSlug}&utm_medium=survey&utm_campaign=survey_pesquisaremunerada`;
    }
  }

  public get paidOnDemandLink(): string {
    return !!process.env.VUE_APP_BASE_URL_PAID_SURVEYS_IFRAME
      ? `${process.env.VUE_APP_BASE_URL_PAID_SURVEYS_IFRAME}?instance=${this.instanceSlug}&journeyId=${this.journeyId}`
      : '';
  }
}
